<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M12.89,11.559999990463258C12.89,11.559999990463258,12.89,11.559999990463258,12.89,11.559999990463258C12.89,11.559999990463258,8.9,3.5599999904632567,8.9,3.5599999904632567C8.9,3.5599999904632567,8.89,3.5599999904632567,8.89,3.5599999904632567C8.719999999999999,3.239999990463257,8.39,3.009999990463257,8,3.009999990463257C7.61,3.009999990463257,7.28,3.239999990463257,7.11,3.5599999904632567C7.11,3.5599999904632567,7.1,3.5599999904632567,7.1,3.5599999904632567C7.1,3.5599999904632567,3.1,11.559999990463258,3.1,11.559999990463258C3.1,11.559999990463258,3.11,11.559999990463258,3.11,11.559999990463258C3.05,11.699999990463256,3,11.849999990463257,3,12.009999990463257C3,12.559999990463258,3.45,13.009999990463257,4,13.009999990463257C4,13.009999990463257,12,13.009999990463257,12,13.009999990463257C12.55,13.009999990463257,13,12.559999990463258,13,12.009999990463257C13,11.849999990463257,12.95,11.699999990463256,12.89,11.559999990463258C12.89,11.559999990463258,12.89,11.559999990463258,12.89,11.559999990463258Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'SymbolTriangleUp',
} as DefineComponent
</script>
